export default __webpack_public_path__ + "static/media/mammoth_mountains.943faa4c.svg";